import { Component, Input } from '@angular/core';

import { PaymentPriceComponent } from '../../payment-price.component';

/**
 * "the_portrait" view of /payment-price.
 *
 * The mockup only shows the no-promo case, but every row the default theme renders is kept
 * here under the same conditions — otherwise a customer who applied a promo code would see a
 * lower total with no explanation of the discount.
 */
@Component({
  selector: 'app-payment-price-portrait',
  templateUrl: './payment-price-portrait.component.html',
  styleUrls: ['./payment-price-portrait.component.scss']
})
export class PaymentPricePortraitComponent {

  @Input() host!: PaymentPriceComponent;

}
